
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";

@Component({
  name: "Navbar",
  components: {
    Breadcrumb,
    Hamburger,
  },
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device.toString();
  }

  get avatar() {
    // return UserModule.avatar;
    //return "@/../img/icons/setting.png";
    return "@/../img/icons/ytologo.ico";
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private async logout() {
    await UserModule.LogOut();
    this.$router.push(`/login?redirect=${this.$route.fullPath}`);
  }
  private async pagerefresh() {
    // await UserModule.LogOut()
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    location.reload();
  }
  private async goto_scanforacceptpacketgeton() {
    // await UserModule.LogOut()
    this.$router.push(`/scanforacceptpacketgeton/index`);
    //location.reload();
  }
}
